import { reactive } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { ErrorMsgState, useErrorMsg } from '@/model/components/common/message/errorMessage'
import { useUserPrelogin } from '@/model/api/user/apiUserPreLogin'
import { useRouterUtil, RouterTypeData } from '@/model/router/router'
import * as log from '@/model/util/log/Logger'
import { focusBlur } from '@/model/util/dom/domUtil'
import { UserResetPasswordState } from './userResetPasswordState'

/**
 * パスワードリセット画面の初期状態を取得する
 * @returns reactiveした初期状態
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useResetPassword = () => {
  const state = reactive<UserResetPasswordState>({
    loading: false,
  })
  return state
}

/**
 * ワンタイムパスワード発行画面遷移を実施する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 * @param error エラーメッセージ状態
 */
const preauth = async (
  state: UserResetPasswordState,
  store: Store<StoreState>,
  router: Router,
  error: ErrorMsgState
) => {
  // 一旦メッセージを全て初期化
  error.data.splice(0)
  // モバイルのためにfocusを外す
  focusBlur()
  // ローディングがONの場合は実行中とみなして何もしない
  if (state.loading) {
    log.debug(`Already running. [preauth]`)
    return
  }
  // ローディングをONにする
  state.loading = true
  // api送信を実施
  const { normaldata } = await useUserPrelogin(store).post(error)
  // ローディングをOFFにする
  state.loading = false
  // レスポンスデータに従い画面遷移を実施する
  if (normaldata) {
    // ワンタイムパスワード発行画面に遷移
    const data: RouterTypeData.EntryAuthSendData = {
      username: store.state.screen.top.username,
      type: RouterTypeData.ENTRY_TYPE.RESET,
    }
    useRouterUtil(router).entryAuthSend(data)
  }
}

export { useResetPassword, preauth, useErrorMsg }
